import { FC, ReactNode, useState, useEffect, useRef } from 'react';

import ReactTooltip from 'react-tooltip';

import './CopyToClipboard.scss';

type Props = {
  id: string;
  text?: string;
  children: ReactNode;
  wrapperClass?: string;
};

const CopyToClipboard: FC<Props> = ({ children, text, id, wrapperClass = '' }) => {
  const [isTextCopied, setTextCopied] = useState(false);
  const copyButtonRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (copyButtonRef.current) {
      copyButtonRef.current.addEventListener('mouseleave', () => setTextCopied(false));
    }
  }, []);

  const copyText = () => {
    if (text) {
      const el = document.createElement('textarea');
      el.value = text || '';
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);

      setTextCopied(true);
    }
  };

  return (
    <div ref={copyButtonRef} data-tip data-for={id} onClick={copyText} className={wrapperClass}>
      {children}
      <ReactTooltip id={id} className="tooltip-for-copy-to-clipboard" place="bottom" type="info" effect="solid">
        <span>{isTextCopied ? _t('Copied!', 'COPY.COPIED') : _t('Click to Copy!', 'COPY.CLICK_TO_COPY')}</span>
      </ReactTooltip>
    </div>
  );
};

export default CopyToClipboard;
